"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getNodeLevels_1 = __importDefault(require("./getNodeLevels"));
const toNodeIdStepNumberPair = ({ nodeId }, index) => [
    nodeId,
    index + 1,
];
const getNodeStepNumbers = (nodes) => {
    const nodeLevels = getNodeLevels_1.default(nodes);
    const nodeIdStepNumberPairs = lodash_1.map(nodeLevels, toNodeIdStepNumberPair);
    return lodash_1.fromPairs(nodeIdStepNumberPairs);
};
exports.default = getNodeStepNumbers;
